import React, { useEffect, useState } from "react";
import SideNav from "../../Layout/SideNav";
import styled from "styled-components";
import { useParams, useHistory } from "react-router";
import { Redirect } from "react-router-dom";
import axios from "axios";
import APIModel from "../../../Models/APIModel";
import alertify from "alertifyjs";
import Loader from "react-loader-spinner";
import ViewInvoiceTable from "./ViewInvoiceTable";
import Grid from "@material-ui/core/Grid";
import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { displayAlertifyError } from "../../../util/functions";

const host = APIModel.HOST;
// const token = localStorage.getItem("Token");
const user_status = localStorage.getItem("status");

const ViewInvoice = () => {
  const history = useHistory();
  const invoiceParamId = useParams().id;

  // states
  const [isMailLoading, setIsMailLoading] = useState(false);
  const [isPaymentLoading, setIsPaymnetLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState({});
  const [clientData, setClientData] = useState({});
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem("Token"));
  const [addressmain, setAddressmain] = useState('');
  // effects
  useEffect(() => {
    getInvoiceData(invoiceParamId);
  }, []);

  useEffect(() => {
    setToken(localStorage.getItem("Token"));
  }, []);

  // functions

  const getInvoiceData = async (invoice_id) => {
    await axios
      .get(host + `show-invoice/${invoice_id}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        setInvoiceData(res.data.data);
        getClientData(res.data.data.client_id);
      })
      .catch((err) => console.log(err));
  };
  function GenrateInvoicepayment(invoiceParamId) {
    setIsPaymnetLoading(true);
    const param = { 'invoice_id': invoiceParamId, 'type': 'invoice' };
    axios.post(host + 'genrate-invoice-link', param, {
      'headers': {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        Authorization: "Bearer " + token
      }
    }).then(res => {
      setIsPaymnetLoading(false);
      alertify.success(res.data.message)
    }).catch(err => alertify.error(err));
  }
  const handleUpdatePaidStatus = (invoice_id) => {
    const param = { invoice_id };
   
    axios
      .post(host + "update-payment-status", param, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        alertify.success(res.data.message);
        // Refresh invoice data from backend so amounts/status reflect server truth.
        getInvoiceData(invoice_id);
      })
      .catch((error) => {
        console.log(error);
        displayAlertifyError({ error: error.message });
      });
  };

  const formatCurrency = (number) => {
    return parseFloat(number).toLocaleString(undefined, {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });
  };
  function updateAddress(clientData) {
    const clientAddress = clientData.address;
    const clientCity = clientData.city;
    const clientState = clientData.state;
    const clientPostalCode = clientData.postel_code;
    
    // Concatenating only if city, state, and postal code are not already in the address
    let address = clientAddress;
    if (!address.includes(clientCity)) {
      if (address.includes(clientState) && address.includes(clientPostalCode)) {
        // If state and postal code already exist, then add city before state
        address = address.replace(clientState, clientCity + ' ' + clientState);
      } else {
        address += ' ' + clientCity;
      }
    }
    if (!address.includes(clientState)) {
      address += ' ' + clientState;
    }
    if (!address.includes(clientPostalCode)) {
      address += ' ' + clientPostalCode;
    }
    
    // Setting the final address
    setAddressmain(address);
  }
  

  const getClientData = async (client_id) => {
    await axios
      .get(host + "client-detail/" + client_id, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        setClientData(res.data.client);
        updateAddress(res.data.client);
        
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        console.log(err);
        displayAlertifyError({ error: err });
      });
  };
  function sendEmail(invoice_id) {
    const param = { invoice_id: invoice_id, type: "invoice" };
    setIsMailLoading(true);
    axios
      .post(APIModel.HOST + "send-email", param, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        alertify.success(res.data.message);
      })
      .catch((err) => displayAlertifyError({ error: err }))
      .finally(() => setIsMailLoading(false));
  }
  function deleteInvoice(id) {
    const param = { id: id };
    setIsDeleteLoading(true);
    axios
      .post(APIModel.HOST + "delete-invoice", param, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        alertify.success(res.data.message);
        setTimeout(() => {
          history.push("/invoices");
        });
      })
      .catch((err) => displayAlertifyError({ error: err.message }))
      .finally(() => setIsDeleteLoading(false));
  }

  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <>
          <div className="wrapper">
            <SideNav />
            <div className="main-panel">
              <div className="content">
                <div className="container-fluid">
                  <DivNewInvoiceHeader>
                    <h3 className="my-0 font-weight-bold">
                      Invoice #{invoiceData.po_number}
                    </h3>
                    <div>
                      {invoiceData.status === 0 ? (

                        
                        isPaymentLoading ? (
                          <button type="button" className="btn btn-primary ml-2" style={{ opacity: "0.5" }}>
                            Payment Requesting
                          </button>
                        ) : (
  <span>
                          <button type="submit" class="btn btn-primary ml-sm-2" onClick={() => handleUpdatePaidStatus(invoiceParamId)}>
                          Invoice paid
                             </button>

                          <button type="button" className="btn btn-primary ml-2" onClick={() => GenrateInvoicepayment(invoiceParamId)}>
                            Payment Request
                          </button> </span>
                         
                        )
                      ) : (
                        <span
                          className="ml-2"
                          style={{
                            display: "inline-block",
                            backgroundColor: "#28a745",
                            color: "#fff",
                            fontWeight: 600,
                            borderRadius: "4px",
                            padding: "8px 14px",
                            verticalAlign: "middle",
                          }}
                        >
                          ✓ Payment Received
                        </span>
                      )}

                      {isMailLoading ? (
                        <button
                          type="disabled"
                          class="btn btn-primary ml-2"
                          style={{ opacity: ".5" }}
                        >
                          Mailing...
                        </button>
                      ) : (
                        <button
                          type="button"
                          class="btn btn-primary ml-2"
                          onClick={() => {
                            sendEmail(invoiceParamId);
                          }}
                        >
                          Mail
                        </button>
                      )}

                      {isDeleteLoading ? (
                        <button
                          type="disabled"
                          class="btn btn-primary"
                          style={{ opacity: ".5" }}
                        >
                          Deleting...
                        </button>
                      ) : (
                        <button
                          type="button"
                          class="btn btn-primary"
                          onClick={() => {
                            deleteInvoice(invoiceParamId);
                          }}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </DivNewInvoiceHeader>
                  {!loading ? (
                    <DivInvoice>
                      <div className="container">
                        <div className="estimate-head">
                          <div className="head-left">
                            <p>
                              {" "}
                              <span className="heading">Name : </span>
                              {clientData.name}
                            </p>
                            <p>
                              {" "}
                              <span className="heading">Address : </span>
                              {addressmain}
                            </p>
                            <p>
                              {" "}
                              <span className="heading">Email : </span>
                              {clientData.email}
                            </p>
                            <p>
                              {" "}
                              <span className="heading">Date : </span>
                              {invoiceData.date}
                            </p>
                          </div>
                          {/* <div className="head-right">
                                                <div>Pixelpk</div>
                                                <div>Joher town g1</div>
                                                <div>+923078801559</div>
                                            </div> */}
                        </div>
                      </div>
                      <ViewInvoiceTable tableItems={invoiceData.items} />
                      <div className="container pt-2">
                        <div className="row">
                          <div className="col-12">
                            <List
                              component="nav"
                              aria-label="secondary mailbox folders"
                            >
                              <ListItem>
                                <ListItemText>Subtotal</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {invoiceData.subtotal === 0
                                      ? "0.00"
                                      : formatCurrency(invoiceData.subtotal)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                              <Divider />
                              <ListItem>
                                <ListItemText>Total Tax</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {invoiceData.tax === 0
                                      ? "0.00"
                                      : formatCurrency(invoiceData.tax)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                              <Divider />
                              <ListItem>
                                <ListItemText>Total Discount</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {invoiceData.discount === 0
                                      ? "0.00"
                                      : formatCurrency(invoiceData.discount)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                              <Divider />
                              <ListItem>
                                <ListItemText>Grand Total</ListItemText>
                                <ListItemSecondaryAction>
                                  <ListItemText>
                                    $
                                    {invoiceData.total === 0
                                      ? "0.00"
                                      : formatCurrency(invoiceData.total)}
                                  </ListItemText>
                                </ListItemSecondaryAction>
                              </ListItem>
                              {invoiceData.status === 1 ? (
                                <>
                                  <Divider />
                                  <ListItem>
                                    <ListItemText>
                                      Payment Received
                                    </ListItemText>
                                    <ListItemSecondaryAction>
                                      <ListItemText>
                                        $
                                        {invoiceData.total === 0
                                          ? "0.00"
                                          : formatCurrency(invoiceData.total)}
                                      </ListItemText>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                  <Divider />
                                  <ListItem>
                                    <ListItemText
                                      primaryTypographyProps={{
                                        style: {
                                          fontWeight: 700,
                                          color: "#28a745",
                                        },
                                      }}
                                    >
                                      Balance Due
                                    </ListItemText>
                                    <ListItemSecondaryAction>
                                      <ListItemText
                                        primaryTypographyProps={{
                                          style: {
                                            fontWeight: 700,
                                            color: "#28a745",
                                          },
                                        }}
                                      >
                                        $0.00
                                      </ListItemText>
                                    </ListItemSecondaryAction>
                                  </ListItem>
                                </>
                              ) : (
                                ""
                              )}
                            </List>
                          </div>
                        </div>
                      </div>

                      <div className="container pt-3">
                        <div className="row">
                          <div className="col-12 mb-4">
                            <Typography variant="h5">Notes</Typography>
                            <br />
                            {invoiceData?.notes &&
                              invoiceData.notes !== "null" &&
                              invoiceData.notes !== "undefined" ? (
                              <Typography
                                variant="body1"
                                sx={{ fontSize: "1.4rem" }}
                              >
                                {invoiceData.notes}
                              </Typography>
                            ) : (
                              "No notes"
                            )}
                          </div>
                          <div className="col-12">
                            <Typography variant="h5">Photos</Typography>
                            <br />
                            <Grid container spacing={2}>
                              {invoiceData.documents.filter(
                                (item) => item.document_type === "photos"
                              ).length > 0
                                ? invoiceData.documents
                                  .filter(
                                    (item) => item.document_type === "photos"
                                  )
                                  .map((item, index) => {
                                    return (
                                      <Grid item xs={3} key={index}>
                                        <span className="image" key={item.id}>
                                          <img
                                            src={
                                              item.url
                                                ? `${item.url}`
                                                : `${item.file_url}`
                                            }
                                            alt={item.document_type}
                                          />
                                          <br />
                                          <span>{item.description}</span>
                                        </span>
                                      </Grid>
                                    );
                                  })
                                : "No photos were selected"}
                            </Grid>
                          </div>
                        </div>
                      </div>

                      <div className="container pt-3">
                        <div className="row">
                          <div className="col-12">
                            <Typography variant="h5">Attachments</Typography>
                            <br />

                            {invoiceData.documents.filter(
                              (item) => item.document_type === "attachments"
                            ).length > 0
                              ? invoiceData.documents
                                .filter(
                                  (item) =>
                                    item.document_type === "attachments"
                                )
                                .map((item) => {
                                  return (
                                    <div>
                                      <a
                                        target="_blank"
                                        href={`${item.file_url}`}
                                      >
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                        >
                                          Download
                                        </button>
                                      </a>
                                    </div>
                                  );
                                })
                              : "No documents were selected"}
                          </div>
                        </div>
                      </div>
                    </DivInvoice>
                  ) : (
                    <DivLoader>
                      <Loader
                        type="Oval"
                        color="#FC3538"
                        height={50}
                        width={50}
                      />
                    </DivLoader>
                  )}
                </div>
              </div>
            </div >
          </div >
        </>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
};

export default ViewInvoice;

const DivNewInvoiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 6px;
  padding: 14px;
  button {
    margin: 0px 5px;
  }
`;
const DivInvoice = styled.div`
  padding: 10px;
  border-radius: 6px;
  background-color: white;
  img {
    margin: 5px;
    width: 150px;
    height: 150px;
    object-fit: cover;
    cursor: pointer;
    transition: 0.25s all ease-in-out;
  }
  .estimate-head {
    margin: 15px 0px;
    display: flex;
    justify-content: space-between;
    .heading {
      font-weight: bold;
      color: black;
    }
    .head-right {
      text-align: right;
    }
  }
`;
const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;
